<div class="container-fluid py-3">
  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div>
      <h2><i class="bi bi-gear text-warning me-2"></i>{{ 'admin_dashboard.title' | translate }}</h2>
      <p class="text-muted mb-0">{{ 'admin_dashboard.subtitle' | translate }}</p>
    </div>
    <button class="btn btn-accent" (click)="createReservation()">
      <i class="bi bi-plus me-2"></i>{{ 'admin_dashboard.new' | translate }}
    </button>
  </div>

  <!-- Tabs -->
  <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs" (activeIdChange)="onTabChange()">
    <li [ngbNavItem]="1">
      <a ngbNavLink><i class="bi bi-calendar-day me-2"></i>{{ 'admin_dashboard.tab_today' | translate }}</a>
      <ng-template ngbNavContent>
        <s-table [cols]="tabToday.cols" [refreshUrl]="tabToday.refreshUrl" [params]="tabToday.params"
          [detailUrl]="tabToday.detailUrl" [detailId]="tabToday.detailId">
        </s-table>
      </ng-template>
    </li>
    <li [ngbNavItem]="2">
      <a ngbNavLink><i class="bi bi-clock me-2"></i>{{ 'admin_dashboard.tab_upcoming' | translate }}</a>
      <ng-template ngbNavContent>
        <s-table [cols]="tabUpcoming.cols" [refreshUrl]="tabUpcoming.refreshUrl" [params]="tabUpcoming.params"
          [detailUrl]="tabUpcoming.detailUrl" [detailId]="tabUpcoming.detailId">
        </s-table>
      </ng-template>
    </li>
    <li [ngbNavItem]="3">
      <a ngbNavLink><i class="bi bi-list me-2"></i>{{ 'admin_dashboard.tab_all' | translate }}</a>
      <ng-template ngbNavContent>
        <s-table [cols]="tabAll.cols" [refreshUrl]="tabAll.refreshUrl" [params]="tabAll.params"
          [detailUrl]="tabAll.detailUrl" [detailId]="tabAll.detailId" [excel]="true">
        </s-table>
      </ng-template>
    </li>
  </ul>

  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
